import BillingProjectsFiltersReducer from '@contexts/BillingProjectsFiltersReducer';
import InvoiceFiltersReducer from '@contexts/InvoiceFiltersReducer';
import PaymentFiltersReducer from '@contexts/PaymentFiltersReducer';
import AreaReducer from '@contexts/AreaReducer';
import LoadingReducer from '@contexts/LoadingReducer';
import TravelPlanFilterReducer from '@contexts/TravelPlanFilterReducer';
import StatementFilterReducer from '@contexts/StatementFilterReducer';
import TaskFiltersReducer from '@contexts/TaskFiltersReducer';
import PackageFiltersReducer from '@contexts/PackageFiltersReducer';

const NavigationReducer = ({
    billingProjectsFiltersContext,
    invoicesFiltersContext,
    paymentsFiltersContext,
    areaContext ,
    loadingStatusContext,
    travelPlanFiltersContext,
    statementFiltersContext,
    taskFiltersContext,
    packageFiltersContext,
}, action) => ({
    billingProjectsFiltersContext: BillingProjectsFiltersReducer(billingProjectsFiltersContext, action),
    invoicesFiltersContext: InvoiceFiltersReducer(invoicesFiltersContext, action),
    paymentsFiltersContext: PaymentFiltersReducer(paymentsFiltersContext, action),
    areaContext: AreaReducer(areaContext, action),
    loadingStatusContext: LoadingReducer(loadingStatusContext, action),
    travelPlanFiltersContext: TravelPlanFilterReducer(travelPlanFiltersContext, action),
    statementFiltersContext: StatementFilterReducer(statementFiltersContext, action),
    taskFiltersContext: TaskFiltersReducer(taskFiltersContext, action),
    packageFiltersContext: PackageFiltersReducer(packageFiltersContext, action)
});

export default NavigationReducer
